
export class ModalInfo {
    messageModal: string;
    type: string;
}

